<section class="content">
  <div class="container-fluid pl-0 pr-0">
      <div class="block-header">
          <div style="margin-top: 2%;    border: 2px solid #446f8b;; margin-bottom: 1%;" [hidden]="!showFilterPanel">
              <div style="margin: 2%;">
                  <div class="master-de">
                      <dynamic-form #docSetForm [repeatCount]=4></dynamic-form>
                      <div class="row">
                          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                              <EIPDatePicker setid="txtToDate" WaterMark="To Date" [Value]="ToDate" (selectedDate)='getSelectedDate($event)' [Min]="projectStartDate" [Max]="projectEndDate"></EIPDatePicker>
                          </div>
                      </div>
                      <button style="float: right;" class="btn btn-primary" id="BtnUpdate" (click)="LoadSCurve()" title="Load Chart"><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;&nbsp;Load Chart</button>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-12 mt-2">
                  <mat-button-toggle-group aria-label="Font Style" class="" (change)="changeButtonToggle($event)" [value]="selectedOption">
                      <mat-button-toggle value="count">Count</mat-button-toggle>
                      <mat-button-toggle value="weightage">Weightage</mat-button-toggle>
                  </mat-button-toggle-group>
              </div>
          </div>
      </div>
      <div class="row" style="float: right;">
          <div class="acc-icon-container view-page-wrap-icons align-items-center d-flex eip-mr-0">
              <p style="font-weight: bold; font-style: italic" *ngIf="isWeightage">Define Progress Level Weightage</p>
              <i title="{{panelOpenState?'Collapse':'Define Status-Wise Weightage Completion Percentage'}}" [ngClass]="panelOpenState?'fa-collapse-all':'fa-pencil'" aria-hidden="true" id="ibtINDVCollapseAll" (click)="$event.stopPropagation();collapseAllClick()" *ngIf="isWeightage"></i>
              <i class="fa fa-filter" title="Filter Documents" (click)="toggleFilter()" aria-hidden="true"></i>
              <i class="fa fa-file-excel-download-o" title="Export Document Details" (click)="GetSCurveExportDetails()" aria-hidden="true"></i>
          </div>
          <div class="col-xl-3"></div>
      </div>
      <div [hidden]="!isWeightage">
          <br>
          <mat-expansion-panel [expanded]="panelOpenState" class="child-mat-expan">
              <br>
              <br>
              <mat-panel-title id="lblDocument">
                  Progress Level Weightage Definition
              </mat-panel-title>
          </mat-expansion-panel>
          <div class="row" *ngIf="panelOpenState">
              <div style="width:50%; margin:2% auto" *ngIf="StatusCompletionPercentageDetails.length > 0">
                  <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
                      <thead style="background: #1063a1; color: white; border-bottom: 2px solid #dee2e6;">
                          <tr style="border-bottom: 1px solid #dee2e6;">
                              <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;">
                                  Sl No.</th>
                              <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Progress Level</th>
                              <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Sequence</th>
                              <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Duration In Days</th>
                              <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Completion Percentage
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let data of  StatusCompletionPercentageDetails;let i=index" style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6; line-height:14px;">
                              <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6; height: 14px;">
                                  {{i+1}}
                              </td>
                              <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">
                                  {{data.deD_Description}}
                              </td>
                              <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">
                                  <input type="number" required [(ngModel)]="data.sequence">
                              </td>
                              <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">
                                  <input type="number" required [(ngModel)]="data.durationInDays">
                              </td>
                              <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">
                                  <input type="number" required [(ngModel)]="data.completion_Percentage">
                              </td>
                          </tr>
                      </tbody>
                  </table>
                  <div style="width:100%">
                      <button style="margin-top: 3%;float: right;" class="btn btn-primary" id="BtnUpdate" (click)="UpdateStatusCompletionPercentage()"><i class="fa fa-re-edit" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Update & Load Chart</button>
                  </div>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <div class="notification">
                      <p style="margin-left: 2%;font-style: italic;"><strong>Note ★</strong> Example to set Duration days :-
                          <br>
                          Schedule date for Progress level n = 01-Jan -2023
                          <br>
                          * Duration for Progress level n+1 set to 10 days,
                          Then , Schedule date for Progress level n+1 = 11-Jan -2023
                      </p>
                  </div>
              </div>
          </div>
          <div class="dashboard-container" *ngIf="!panelOpenState">
              <div class="row row-10 eip-mt-20">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="eip-panel-body eip-pxy-10">
                          <div class="eip-panel-header">
                              <h6 style="font-weight: bold;">Total Document Weightage Index Planned from {{projectStartDate | date:'dd-MMM-yyyy'}} to {{ToDate | date:'dd-MMM-yyyy'}} is : {{TotalValue}}</h6>
                          </div>
                          <div class="eip-pt-0">
                              <kendo-chart>
                                  <kendo-chart-title></kendo-chart-title>
                                  <kendo-chart-legend [title]="{ text: '' }" position="bottom">
                                  </kendo-chart-legend>
                                  <kendo-chart-series>
                                      <kendo-chart-series-item *ngFor="let item of sCurveDetails" type="line" [name]="item.status" [data]="item.doc_Value" [labels]="seriesLabels"></kendo-chart-series-item>
                                  </kendo-chart-series>
                                  <kendo-chart-category-axis>
                                      <kendo-chart-category-axis-item [categories]="category" [name]="'category'" [type]="'category'" [labels]="{ rotation: 'auto', step: 1 }">
                                      </kendo-chart-category-axis-item>
                                  </kendo-chart-category-axis>
                              </kendo-chart>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div [hidden]="isWeightage">
          <br>
          <div class="dashboard-container">
              <div class="row row-10 eip-mt-20">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="eip-panel-body eip-pxy-10">
                          <div class="eip-panel-header">
                              <h6 style="font-weight: bold;">Total Documents Scheduled from {{projectStartDate | date:'dd-MMM-yyyy'}} to {{ToDate | date:'dd-MMM-yyyy'}} is : {{TotalValue}}</h6>
                          </div>
                          <div class="eip-pt-0">
                              <kendo-chart [transitions]="true">
                                  <kendo-chart-title></kendo-chart-title>
                                  <kendo-chart-legend [title]="{ text: '' }" position="bottom">
                                  </kendo-chart-legend>
                                  <kendo-chart-series>
                                      <kendo-chart-series-item *ngFor="let item of sCurveDetails" type="line" [name]="item.status" [data]="item.doc_Value" [labels]="seriesLabels"></kendo-chart-series-item>
                                  </kendo-chart-series>
                                  <kendo-chart-category-axis>
                                      <kendo-chart-category-axis-item [categories]="category" [name]="'category'" [type]="'category'" [labels]="{ rotation: 'auto', step: 1 }">
                                      </kendo-chart-category-axis-item>
                                  </kendo-chart-category-axis>
                              </kendo-chart>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>